var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('main-link'), _c('main-section', {
    attrs: {
      "id": "efesta",
      "title": "e커머스피칭페스타"
    }
  }, [_c('v-img', {
    staticClass: "main-section__number",
    attrs: {
      "contain": "",
      "max-width": "230",
      "src": "/images/main/section-number-1.png"
    }
  }), _c('main-section', {
    staticClass: "py-0",
    scopedSlots: _vm._u([{
      key: "mainSectionImmersive",
      fn: function fn() {
        return [_c('tit-bar', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("경진대회를 통한 혁신성장 생태계 조성")];
            },
            proxy: true
          }, {
            key: "text",
            fn: function fn() {
              return [_vm._v(" 유통물류서비스에 적용 가능한 혁신 기술을 보유한 기업을 발굴하여"), _c('br', {
                staticClass: "d-none d-lg-block"
              }), _vm._v(" 투자유치 기회 제공 및 사업홍보 지원 ")];
            },
            proxy: true
          }, {
            key: "button",
            fn: function fn() {
              return [_c('v-btn', {
                staticClass: "min-w-140px min-w-lg-180px justify-space-between",
                attrs: {
                  "x-large": "",
                  "outlined": "",
                  "color": "secondary",
                  "to": "/pitching-festa"
                }
              }, [_vm._v(" 더 보기 "), _c('icon-arrow-rounded', {
                staticClass: "icon--size-small ml-12px",
                attrs: {
                  "direction": "right"
                }
              })], 1)];
            },
            proxy: true
          }])
        }), _c('v-card', {
          staticClass: "border-light text-center",
          attrs: {
            "outlined": "",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-row', {
          attrs: {
            "no-gutters": "",
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "6",
            "md": "4"
          }
        }, [_c('div', {
          staticClass: "px-12px py-20px py-md-40px py-lg-60px"
        }, [_c('div', {
          staticClass: "mb-20px mb-md-40px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": _vm.$vuetify.breakpoint.mdAndUp ? 160 : 90,
            "aspect-ratio": 1 / 1,
            "src": "/images/main/main-pitching-festa-icon.png"
          }
        })], 1), _c('div', {
          staticClass: "tit tit--xxs break-keep"
        }, [_vm._v("유통사·투자사·기술사 "), _c('br', {
          staticClass: "d-none d-md-block"
        }), _vm._v("대상 피칭")])])]), _c('v-col', {
          staticClass: "d-none d-md-block ml-md-n1px align-self-stretch",
          attrs: {
            "cols": "12",
            "md": "auto"
          }
        }, [_c('div', {
          staticClass: "h-100 py-40px py-lg-60px"
        }, [_c('v-divider', {
          staticClass: "h-100",
          attrs: {
            "vertical": ""
          }
        })], 1)]), _c('v-col', {
          attrs: {
            "cols": "6",
            "md": "4"
          }
        }, [_c('div', {
          staticClass: "px-12px py-20px py-md-40px py-lg-60px"
        }, [_c('div', {
          staticClass: "mb-20px mb-md-40px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": _vm.$vuetify.breakpoint.mdAndUp ? 160 : 90,
            "aspect-ratio": 1 / 1,
            "src": "/images/main/main-pitching-festa-icon2.png"
          }
        })], 1), _c('div', {
          staticClass: "tit tit--xxs break-keep"
        }, [_vm._v("네트워킹")])])]), _c('v-col', {
          staticClass: "d-none d-md-block ml-md-n1px align-self-stretch",
          attrs: {
            "cols": "12",
            "md": "auto"
          }
        }, [_c('div', {
          staticClass: "h-100 py-40px py-lg-60px"
        }, [_c('v-divider', {
          staticClass: "h-100",
          attrs: {
            "vertical": ""
          }
        })], 1)]), _c('v-col', {
          attrs: {
            "cols": "6",
            "md": "4"
          }
        }, [_c('div', {
          staticClass: "px-12px py-20px py-md-40px py-lg-60px"
        }, [_c('div', {
          staticClass: "mb-20px mb-md-40px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": _vm.$vuetify.breakpoint.mdAndUp ? 160 : 90,
            "aspect-ratio": 1 / 1,
            "src": "/images/main/main-pitching-festa-icon3.png"
          }
        })], 1), _c('div', {
          staticClass: "tit tit--xxs break-keep"
        }, [_vm._v("사업홍보를 위한 "), _c('br', {
          staticClass: "d-none d-md-block"
        }), _vm._v("스타트업 부스지원")])])])], 1)], 1)];
      },
      proxy: true
    }])
  }), _c('main-section', {
    staticClass: "pb-0",
    scopedSlots: _vm._u([{
      key: "mainSectionImmersive",
      fn: function fn() {
        return [_c('tit-bar', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("성과")];
            },
            proxy: true
          }])
        }), _c('v-card', {
          staticClass: "border-light text-center",
          attrs: {
            "outlined": "",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-row', {
          attrs: {
            "no-gutters": "",
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "6",
            "md": "4"
          }
        }, [_c('div', {
          staticClass: "px-12px py-20px py-md-40px py-lg-60px"
        }, [_c('div', {
          staticClass: "mb-20px mb-md-40px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": _vm.$vuetify.breakpoint.mdAndUp ? 160 : 90,
            "aspect-ratio": 1 / 1,
            "src": "/images/main/main-pitching-festa-icon4.png"
          }
        })], 1), _c('div', {
          staticClass: "tit tit--xxs mb-6px mb-md-10px"
        }, [_vm._v("발굴기업")]), _c('div', {
          staticClass: "d-flex align-center justify-center txt txt--sm txt--dark line-height-1"
        }, [_c('span', {
          staticClass: "pr-4px pr-md-8px"
        }, [_vm._v("총")]), _c('strong', {
          staticClass: "font-size-24 font-size-md-40 font-size-lg-56 line-height-1 primary--text"
        }, [_vm._v("203")]), _c('span', {
          staticClass: "pl-4px pl-md-8px"
        }, [_vm._v("개사")])])])]), _c('v-col', {
          staticClass: "d-none d-md-block ml-md-n1px align-self-stretch",
          attrs: {
            "cols": "12",
            "md": "auto"
          }
        }, [_c('div', {
          staticClass: "h-100 py-40px py-lg-60px"
        }, [_c('v-divider', {
          staticClass: "h-100",
          attrs: {
            "vertical": ""
          }
        })], 1)]), _c('v-col', {
          attrs: {
            "cols": "6",
            "md": "4"
          }
        }, [_c('div', {
          staticClass: "px-12px py-20px py-md-40px py-lg-60px"
        }, [_c('div', {
          staticClass: "mb-20px mb-md-40px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": _vm.$vuetify.breakpoint.mdAndUp ? 160 : 90,
            "aspect-ratio": 1 / 1,
            "src": "/images/main/main-pitching-festa-icon5.png"
          }
        })], 1), _c('div', {
          staticClass: "tit tit--xxs mb-6px mb-md-10px"
        }, [_vm._v("투자금액")]), _c('div', {
          staticClass: "d-flex align-center justify-center txt txt--sm txt--dark line-height-1"
        }, [_c('span', {
          staticClass: "pr-4px pr-md-8px"
        }, [_vm._v("총")]), _c('strong', {
          staticClass: "font-size-24 font-size-md-40 font-size-lg-56 line-height-1 primary--text"
        }, [_vm._v("1,884")]), _c('span', {
          staticClass: "pl-4px pl-md-8px"
        }, [_vm._v("억원")])])])]), _c('v-col', {
          staticClass: "d-none d-md-block ml-md-n1px align-self-stretch",
          attrs: {
            "cols": "12",
            "md": "auto"
          }
        }, [_c('div', {
          staticClass: "h-100 py-40px py-lg-60px"
        }, [_c('v-divider', {
          staticClass: "h-100",
          attrs: {
            "vertical": ""
          }
        })], 1)]), _c('v-col', {
          attrs: {
            "cols": "6",
            "md": "4"
          }
        }, [_c('div', {
          staticClass: "px-12px py-20px py-md-40px py-lg-60px"
        }, [_c('div', {
          staticClass: "mb-20px mb-md-40px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": _vm.$vuetify.breakpoint.mdAndUp ? 160 : 90,
            "aspect-ratio": 1 / 1,
            "src": "/images/main/main-pitching-festa-icon6.png"
          }
        })], 1), _c('div', {
          staticClass: "tit tit--xxs mb-6px mb-md-10px"
        }, [_vm._v("사업협업연계")]), _c('div', {
          staticClass: "d-flex align-center justify-center txt txt--sm txt--dark line-height-1"
        }, [_c('span', {
          staticClass: "pr-4px pr-md-8px"
        }, [_vm._v("총")]), _c('strong', {
          staticClass: "font-size-24 font-size-md-40 font-size-lg-56 line-height-1 primary--text"
        }, [_vm._v("50")]), _c('span', {
          staticClass: "pl-4px pl-md-8px"
        }, [_vm._v("개사")])])])])], 1)], 1)];
      },
      proxy: true
    }])
  }), _c('main-section', {
    staticClass: "pb-0",
    scopedSlots: _vm._u([{
      key: "mainSectionImmersive",
      fn: function fn() {
        return [_c('tit-bar', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("연도별 수상기업")];
            },
            proxy: true
          }, {
            key: "button",
            fn: function fn() {
              return [_c('v-btn', {
                staticClass: "min-w-140px min-w-lg-180px justify-space-between",
                attrs: {
                  "x-large": "",
                  "outlined": "",
                  "color": "secondary",
                  "to": "/pitching-festa/startup"
                }
              }, [_vm._v(" 더 보기 "), _c('icon-arrow-rounded', {
                staticClass: "icon--size-small ml-12px",
                attrs: {
                  "direction": "right"
                }
              })], 1)];
            },
            proxy: true
          }])
        }), _c('div', {
          staticClass: "logo-slide"
        }, [_c('div', {
          staticClass: "swiper-container"
        }, [_c('div', {
          staticClass: "swiper-wrapper"
        }, _vm._l(_vm.awards, function (award) {
          var _award$image;
          return _c('div', {
            key: award === null || award === void 0 ? void 0 : award._id,
            staticClass: "swiper-slide"
          }, [_c('v-card', {
            staticClass: "border-light",
            attrs: {
              "outlined": ""
            }
          }, [_c('div', {
            staticClass: "logo-slide__img",
            style: "background-image:url(".concat(award === null || award === void 0 ? void 0 : (_award$image = award.image) === null || _award$image === void 0 ? void 0 : _award$image.src, ")"),
            on: {
              "click": function click($event) {
                return _vm.move(award);
              }
            }
          })])], 1);
        }), 0)])])];
      },
      proxy: true
    }])
  })], 1), _c('main-section', {
    staticClass: "secondary white--text",
    attrs: {
      "id": "circulation",
      "title": "유통데이터 활용 경진대회"
    }
  }, [_c('v-img', {
    staticClass: "main-section__number",
    attrs: {
      "contain": "",
      "max-width": "230",
      "src": "/images/main/section-number-2.png"
    }
  }), _c('main-section', {
    staticClass: "py-0",
    scopedSlots: _vm._u([{
      key: "mainSectionImmersive",
      fn: function fn() {
        return [_c('tit-bar', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("데이터를 활용한 새로운 전략 제시")];
            },
            proxy: true
          }, {
            key: "text",
            fn: function fn() {
              return [_c('span', {
                staticClass: "white--text"
              }, [_vm._v("유통데이터 서비스 플랫폼에서 제공하는 데이터를 활용하여 "), _c('br', {
                staticClass: "d-none d-lg-block"
              }), _vm._v(" 유통산업의 새로운 전략을 제시할 수 있는 사례를 발굴/공유")])];
            },
            proxy: true
          }, {
            key: "button",
            fn: function fn() {
              return [_c('v-btn', {
                staticClass: "min-w-140px min-w-lg-180px justify-space-between",
                attrs: {
                  "x-large": "",
                  "outlined": "",
                  "color": "white",
                  "to": "/circulation"
                }
              }, [_vm._v(" 더 보기 "), _c('icon-arrow-rounded', {
                staticClass: "icon--size-small ml-12px",
                attrs: {
                  "direction": "right"
                }
              })], 1)];
            },
            proxy: true
          }])
        }), _c('div', {
          attrs: {
            "data-aos": "fade",
            "data-aos-delay": "200"
          }
        }, [_c('v-img', {
          staticClass: "d-md-none mx-auto",
          attrs: {
            "max-width": "460",
            "aspect-ratio": 672 / 2586,
            "src": "/images/main/main-circulation-img-mo.png"
          }
        }), _c('v-img', {
          staticClass: "d-none d-md-block",
          attrs: {
            "aspect-ratio": 1200 / 632,
            "src": "/images/main/main-circulation-img.png"
          }
        })], 1)];
      },
      proxy: true
    }])
  }), _c('main-section', {
    staticClass: "pb-0",
    scopedSlots: _vm._u([{
      key: "mainSectionImmersive",
      fn: function fn() {
        return [_c('tit-bar', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("연도별 수상작")];
            },
            proxy: true
          }, {
            key: "button",
            fn: function fn() {
              return [_c('v-btn', {
                staticClass: "min-w-140px min-w-lg-180px justify-space-between",
                attrs: {
                  "x-large": "",
                  "outlined": "",
                  "color": "white",
                  "to": "/circulation/data"
                }
              }, [_vm._v(" 더 보기 "), _c('icon-arrow-rounded', {
                staticClass: "icon--size-small ml-12px",
                attrs: {
                  "direction": "right"
                }
              })], 1)];
            },
            proxy: true
          }])
        }), _c('div', {
          staticClass: "pb-24px"
        }, [_c('h3', {
          staticClass: "tit tit--xxs",
          attrs: {
            "data-aos": "fade-right",
            "data-aos-delay": "300"
          }
        }, [_vm._v("2022년도")]), _c('v-divider', {
          staticClass: "border-2 white mt-10px",
          attrs: {
            "data-aos": "fade",
            "data-aos-delay": "300"
          }
        })], 1), _c('v-row', {
          staticClass: "row--lg"
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4",
            "data-aos": "fade-up",
            "data-aos-delay": "400"
          }
        }, [_c('v-card', {
          staticClass: "border-light",
          attrs: {
            "min-height": "170",
            "to": "/circulation/data/64d32da6182f802bee8a1f8c"
          }
        }, [_c('div', {
          staticClass: "pa-16px pa-md-24px"
        }, [_c('v-img', {
          staticClass: "mb-6px",
          attrs: {
            "max-width": "32",
            "aspect-ratio": 1 / 1,
            "src": "/images/main/main-circulation-icon.png"
          }
        }), _c('h3', {
          staticClass: "tit tit--xxs mb-6px mb-md-10px"
        }, [_vm._v("AIVLE")]), _c('div', {
          staticClass: "txt txt--sm"
        }, [_vm._v("코로나 시대에 따른 소비 패턴의 변화와 이에 대응하는 유통/판매 전략 수립 방안")])], 1)])], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4",
            "data-aos": "fade-up",
            "data-aos-delay": "500"
          }
        }, [_c('v-card', {
          staticClass: "border-light",
          attrs: {
            "min-height": "170",
            "to": "/circulation/data/64d33f4b182f802bee8a2124"
          }
        }, [_c('div', {
          staticClass: "pa-16px pa-md-24px"
        }, [_c('v-img', {
          staticClass: "mb-6px",
          attrs: {
            "max-width": "32",
            "aspect-ratio": 1 / 1,
            "src": "/images/main/main-circulation-icon.png"
          }
        }), _c('h3', {
          staticClass: "tit tit--xxs mb-6px mb-md-10px"
        }, [_vm._v("내일은 분석왕")]), _c('div', {
          staticClass: "txt txt--sm"
        }, [_vm._v("소비자 선호를 기반한 전략적 과일묶기")])], 1)])], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12",
            "md": "4",
            "data-aos": "fade-up",
            "data-aos-delay": "600"
          }
        }, [_c('v-card', {
          staticClass: "border-light",
          attrs: {
            "min-height": "170",
            "to": "/circulation/data/64d345fb182f802bee8a21a0"
          }
        }, [_c('div', {
          staticClass: "pa-16px pa-md-24px"
        }, [_c('v-img', {
          staticClass: "mb-6px",
          attrs: {
            "max-width": "32",
            "aspect-ratio": 1 / 1,
            "src": "/images/main/main-circulation-icon.png"
          }
        }), _c('h3', {
          staticClass: "tit tit--xxs mb-6px mb-md-10px"
        }, [_vm._v("구칠스타")]), _c('div', {
          staticClass: "txt txt--sm"
        }, [_vm._v("오팔세대 맞춤형 상품 개발")])], 1)])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('main-section', {
    staticClass: "main-section--last main-section--education",
    attrs: {
      "title": "유통데이터 활용 교육∙법률지원"
    },
    scopedSlots: _vm._u([{
      key: "mainSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "main-section__bg",
          staticStyle: {
            "background-image": "url(/images/main/main-education-bg.png)"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('v-img', {
    staticClass: "main-section__number",
    attrs: {
      "contain": "",
      "max-width": "230",
      "src": "/images/main/section-number-3.png"
    }
  }), _c('main-section', {
    staticClass: "py-0",
    scopedSlots: _vm._u([{
      key: "mainSectionImmersive",
      fn: function fn() {
        return [_c('tit-bar', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("유통데이터 활용 교육 소개")];
            },
            proxy: true
          }, {
            key: "button",
            fn: function fn() {
              return [_c('v-btn', {
                staticClass: "min-w-140px min-w-lg-180px justify-space-between",
                attrs: {
                  "x-large": "",
                  "outlined": "",
                  "color": "secondary",
                  "to": "/education"
                }
              }, [_vm._v(" 더 보기 "), _c('icon-arrow-rounded', {
                staticClass: "icon--size-small ml-12px",
                attrs: {
                  "direction": "right"
                }
              })], 1)];
            },
            proxy: true
          }])
        }), _c('v-row', {
          staticClass: "row--xl"
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "data-aos": "fade-up",
            "data-aos-delay": "300"
          }
        }, [_c('v-card', {
          staticClass: "border-light",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-img', {
          attrs: {
            "aspect-ratio": 568 / 378,
            "src": "/images/main/main-education-img.jpg"
          }
        }), _c('v-divider', {
          staticClass: "border-light"
        }), _c('div', {
          staticClass: "pa-20px pa-md-30px"
        }, [_c('h3', {
          staticClass: "tit tit--xs mb-6px mb-md-10px"
        }, [_vm._v("온라인 플랫폼 교육")]), _c('div', {
          staticClass: "txt txt--lg"
        }, [_vm._v("기술기업이 유통물류에 적용 가능한 리테일 기술 개발 시 "), _c('br', {
          staticClass: "d-none d-xl-block"
        }), _vm._v("유통시장에 빠르게 진출할 수 있도록 온라인 커머스에 대한 "), _c('br', {
          staticClass: "d-none d-xl-block"
        }), _vm._v("이해력 제고")])])], 1)], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "6",
            "data-aos": "fade-up",
            "data-aos-delay": "400"
          }
        }, [_c('v-card', {
          staticClass: "border-light",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-img', {
          attrs: {
            "aspect-ratio": 568 / 378,
            "src": "/images/main/main-education-img2.jpg"
          }
        }), _c('v-divider', {
          staticClass: "border-light"
        }), _c('div', {
          staticClass: "pa-20px pa-md-30px"
        }, [_c('h3', {
          staticClass: "tit tit--xs mb-6px mb-md-10px"
        }, [_vm._v("유통데이터 활용 교육")]), _c('div', {
          staticClass: "txt txt--lg"
        }, [_vm._v("유통물류, 제조, IT기업 대상 다양한 데이터를 활용하여 "), _c('br', {
          staticClass: "d-none d-xl-block"
        }), _vm._v("비즈니스 전략 수립과 수요 예측, 마케팅, 데이터 분석 등 데이터 "), _c('br', {
          staticClass: "d-none d-xl-block"
        }), _vm._v("활용 이해도 증진")])])], 1)], 1)], 1)];
      },
      proxy: true
    }])
  }), _c('main-section', {
    staticClass: "pb-0",
    scopedSlots: _vm._u([{
      key: "mainSectionImmersive",
      fn: function fn() {
        return [_c('tit-bar', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("유통데이터 활용 법률 자문 지원")];
            },
            proxy: true
          }, {
            key: "button",
            fn: function fn() {
              return [_c('v-btn', {
                staticClass: "min-w-140px min-w-lg-180px justify-space-between",
                attrs: {
                  "x-large": "",
                  "outlined": "",
                  "color": "secondary",
                  "to": "/education/law"
                }
              }, [_vm._v(" 더 보기 "), _c('icon-arrow-rounded', {
                staticClass: "icon--size-small ml-12px",
                attrs: {
                  "direction": "right"
                }
              })], 1)];
            },
            proxy: true
          }])
        }), _c('v-card', {
          staticClass: "white--text",
          attrs: {
            "img": "/images/main/main-education-img3.jpg",
            "data-aos": "fade",
            "data-aos-delay": "300"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1200 / 400
          }
        }, [_c('div', {
          staticClass: "d-flex h-100"
        }, [_c('div', {
          staticClass: "px-20px pt-60px pb-20px px-md-40px pb-md-40px mt-auto"
        }, [_c('h3', {
          staticClass: "tit tit--xs mb-6px mb-md-10px"
        }, [_vm._v("유통데이터 활용 기업 대상 법률 지원체계구축")]), _c('div', {
          staticClass: "txt txt--lg white--text"
        }, [_vm._v("유통데이터를 수집·가공·제공 등 활용하는 과정에서 수반되는 법률적 쟁점을 사전 발굴·검토하여 "), _c('br', {
          staticClass: "d-none d-xl-block"
        }), _vm._v("리스크를 방지하고 수시로 발생하는 법적 이슈를 신속하고 효율적으로 지원")])])])])], 1)];
      },
      proxy: true
    }])
  }), _c('main-section', {
    staticClass: "pb-0",
    scopedSlots: _vm._u([{
      key: "mainSectionImmersive",
      fn: function fn() {
        return [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6"
          }
        }, [_c('main-applications')], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "pt-60px pt-lg-0 pl-lg-60px"
        }, [_c('div', {
          staticClass: "tit-wrap"
        }, [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": "auto",
            "data-aos": "fade-right",
            "data-aos-delay": "100"
          }
        }, [_c('h3', {
          staticClass: "tit tit--bar"
        }, [_vm._v("공지사항")])]), _c('v-spacer'), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "auto",
            "data-aos": "fade-left",
            "data-aos-delay": "100"
          }
        }, [_c('v-btn', {
          attrs: {
            "icon": "",
            "tile": "",
            "outlined": "",
            "color": "grey",
            "to": "/center/notice"
          }
        }, [_c('v-icon', {
          attrs: {
            "size": "24"
          }
        }, [_vm._v("mdi-plus")])], 1)], 1)], 1)], 1), _c('main-notice')], 1)])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }